"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoPlayer = void 0;
var constants_1 = require("../data/constants");
function videoPlayer() {
    var videoPlays = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_PLAY, "]"));
    videoPlays === null || videoPlays === void 0 ? void 0 : videoPlays.forEach(function (videoPlay) {
        videoPlay.addEventListener('click', function (e) {
            var video = videoPlay.closest("[".concat(constants_1.DATA_VIDEO_WRAP, "]")).querySelector('iframe');
            video.src += '&autoplay=1';
            e.preventDefault();
        });
    });
}
exports.videoPlayer = videoPlayer;
